module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iaS1jb21wb3NlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRjb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPgogICAgPHBhdGggZD0iTTI3IDE1IEwyNyAzMCAyIDMwIDIgNSAxNyA1IE0zMCA2IEwyNiAyIDkgMTkgNyAyNSAxMyAyMyBaIE0yMiA2IEwyNiAxMCBaIE05IDE5IEwxMyAyMyBaIiAvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-compose.svg
// module id = Idqy
// module chunks = 53